import { Button, Checkbox, FormControl, FormControlLabel, FormHelperText, Grid2, InputAdornment, OutlinedInput, Paper, TextField, Typography, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import './signup.css';
import signupImg from '../../assets/images/signup.png';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import PasswordIcon from '@mui/icons-material/Password';
import config from '../../config/config.js';
import userIcon from '../../assets/icons/userIcon.png';
import passwordIcon from '../../assets/icons/Password.png';
import Logo from '../../assets/images/logo.png';
import { CheckBox } from '@mui/icons-material';
import {makeGetRequestToUrl, makePostRequestToUrl} from '../commonFunc.jsx';
import { initFirebase } from '../../utils/Firebase/firebase';
import  {firebaseConfig }   from '../../constant';
// import { setupNotifications }  from '../Notification/NotificationSetup.jsx';

var constants = require('../../constant');

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const Signup = () => {
    // State to capture email and password
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [emailError, setEmailError] = useState('');
    const [remember, setRemember] = useState(false);
    const navigate = useNavigate();
    const serverUrl = config.serverUrl;
    const [otpModalOpen, setOtpModalOpen] = useState(false);
    const [otp, setOtp] = useState('');
    const [otpError, setOtpError] = useState('');
    const [otpLoading, setOtpLoading] = useState(false);
    const [token,setToken] = useState('');

    const tmsClientId = [164];
    const rizzoClientId = [170];

    useEffect(() => {
        const savedEmail = localStorage.getItem('rememberedEmail');
        const savedPassword = localStorage.getItem('rememberedPassword');
    
        if (savedEmail && savedPassword) {
          setEmail(savedEmail);
          setPassword(savedPassword);
          setRemember(true);
        }
    }, []);

    const handleCheckboxChange = (event) => {
        setRemember(event.target.checked);
    };

    const handleOtpClose = () => {
        setOtpModalOpen(false);
        setOtp('');
        setOtpError('');
    };

    const handleOtpSubmit = async () => {
        if (!otp.trim()) {
            setOtpError('Please enter the OTP.');
            return;
        }
        // setOtpModalOpen(false);
        await handleLogin({ preventDefault: () => {} });
    };

    const validateEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const handleEmailChange = (e) => {
        const value = e.target.value;
        setEmail(value);
        if (value && !validateEmail(value)) {
            setEmailError('Please enter a valid email address');
        } else {
            setEmailError('');
        }
    };

    // Function to handle login
    const handleLogin = async (event) => {
    event.preventDefault(); // Prevents form refresh

    // ✅ Handle Remember Me *without* nuking localStorage first
    if (remember) {
        localStorage.setItem("rememberedEmail", email);
        localStorage.setItem("rememberedPassword", password);
    } else {
        localStorage.removeItem("rememberedEmail");
        localStorage.removeItem("rememberedPassword");
    }

    try {
        const response = await fetch(serverUrl + "/admin-panel/login", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            email,
            password,
             ...(otp && { otp }),
        }),
        });

        const data = await response.json();
        if (!response.ok) {
            setError(data.message || "Login failed. Please try again.");
            setOtpModalOpen(false);
            return;
        }
        if (data.flag === 410 && otpModalOpen) {
            setOtpModalOpen(true);
            setOtpError( 'Invalid OTP. Please try again.');
            return;
        }
        if (data.flag === 413) {
            setOtp('');
            setOtpError('');
            setOtpModalOpen(true);
            return;
        }

        // ✅ Preserve remembered creds when clearing storage
        const rememberedEmail = localStorage.getItem("rememberedEmail");
        const rememberedPassword = localStorage.getItem("rememberedPassword");

        localStorage.clear();
        sessionStorage.clear();

        if (rememberedEmail && rememberedPassword) {
        localStorage.setItem("rememberedEmail", rememberedEmail);
        localStorage.setItem("rememberedPassword", rememberedPassword);
        }

        // ✅ Store login data
        // setToken(data.data.token);
        localStorage.setItem("token", data.data.token);
        localStorage.setItem("cities", JSON.stringify(data.data.client_cities));
        localStorage.setItem("cityId", data.data.city_id);
        localStorage.setItem("clientId", data.data.client_id);
            const currentTime = new Date().getTime().toString();
        localStorage.setItem("lastActivity", currentTime);
        localStorage.setItem("clientRoleTabs", JSON.stringify(data.data.client_tabs));
        localStorage.setItem("clientDemoType", data.data.client_demo_type);
        localStorage.setItem("clientRole", data.data.client_role);
        localStorage.setItem("clientTabPermission", JSON.stringify(data.data.client_tab_permissions));
        localStorage.setItem("country_code", data.data.client_country_code);
        localStorage.setItem("unseen_notification_count", data.data.unseen_notification_count);
        localStorage.setItem('admin_id',data.data.admin_id);
        localStorage.setItem('client_role_id',data.data.client_role);
        sessionStorage.setItem("justLoggedIn", "true");
        sessionStorage.setItem("clientId", data.data.client_id);
        localStorage.setItem('shuttle_analytics_reports',data.data.shuttle_analytics_reports);
        localStorage.setItem("hideuserinfo",data.data.hide_user_info || 0);
        localStorage.setItem("hidedriverinfo",data.data.hide_driver_info || 0);
        localStorage.setItem('corporateId', data.data.corporate_id || 0);
        localStorage.setItem('fleetId', data.data.fleet_id || 0);
        localStorage.setItem('merchantId', data.data.merchant_id || 0);

        const clientId = localStorage.getItem("clientId");
        if (!clientId) {
        console.error("❌ No client ID found in localStorage");
        }

        const clientFirebaseConfig = firebaseConfig[clientId];

        if (!clientFirebaseConfig) {
        console.warn(`⚠ Firebase not enabled for client ${clientId}. Skipping Firebase setup.`);
        }

        if (data.data.client_brand_logo) {
        localStorage.setItem("client_brand_logo", data.data.client_brand_logo);
        } else {
        localStorage.setItem("client_brand_logo", Logo);
        }

        localStorage.setItem("client_favicon", data.data.client_favicon);

        // Update favicon immediately after login
        if (data.data.client_favicon) {
        const link = document.querySelector("#dynamic-favicon");
        if (link) {
            link.href = data.data.client_favicon;
        }
        }

        // 🔐 Load panel feature flags / keys
        fetchCientKeys();

        // ❗❗ IMPORTANT: DO *NOT* do any Firebase / SW work here.
        // Token update & messaging will be handled by NotificationSetup.jsx

        // ✅ Navigate based on client tabs (unchanged)
        const clientTabs = data.data.client_tabs;
        if (clientTabs && clientTabs.length > 0) {
        const tabIds = clientTabs.split(",");

        if (tmsClientId.includes(data.data.client_id)) {
            if (tabIds.includes("54")) {
            navigate("/tms-dashboard");
            } else {
            navigateToFirstAvailableTab(tabIds);
            }
        } else if (rizzoClientId.includes(data.data.client_id)) {
            if (tabIds.includes("57")) {
            navigate("/at-dashboard");
            } else {
            navigateToFirstAvailableTab(tabIds);
            }
        } else {
            if (tabIds.includes("19")) {
            navigate(constants.TabRoutes[19]);
            } else {
            navigateToFirstAvailableTab(tabIds);
            }
        }
        } else {
            window.location.reload();
            navigate("/mainDashboard");
        }
    } catch (error) {
        console.error(error);
        setError("An error occurred. Please try again later.");
    }
    };


    const fetchCientKeys = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/panel/client_keys';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                timestamp: timestamp,
                keys: constants.loginKeys
            };
            const response =  await makePostRequestToUrl(url, body);
            if(response.flag==200){
                // Filter active vehicles
                const resData = response.data;

                localStorage.setItem('add_driver_enabled_for_panel', resData.add_driver_enabled_for_panel);
                localStorage.setItem('driver_vehicle_attachment_enabled', resData.driver_vehicle_attachment_enabled);
                localStorage.setItem('is_client_owned_vehicle', resData.is_client_owned_vehicle);
                localStorage.setItem('is_tms_add_driver', resData.is_tms_add_driver);
                localStorage.setItem('is_tms_driver', resData.is_tms_driver);
                localStorage.setItem('add_customer_enabled_for_panel', resData.add_customer_enabled_for_panel);
                localStorage.setItem('is_rizzo_client', resData.is_rizzo_client);
                localStorage.setItem('taxi_show_mark_arrived_button', resData.taxi_show_mark_arrived_button);
                localStorage.setItem('taxi_show_start_ride_button', resData.taxi_show_start_ride_button);
                localStorage.setItem('taxi_show_end_ride_button', resData.taxi_show_end_ride_button);
                localStorage.setItem('taxi_show_reassign_ride_button', resData.taxi_show_reassign_ride_button);
                localStorage.setItem('taxi_show_mark_arrived_button_for_stops', resData.taxi_show_mark_arrived_button_for_stops);
                localStorage.setItem('date_format_dd_mm_yy', resData.date_format_dd_mm_yy);
                localStorage.setItem('change_point_to_comma', resData.change_point_to_comma);
                localStorage.setItem('google_key', resData.google_key);
                localStorage.setItem('map_search_zone', resData.map_search_zone);
                localStorage.setItem('remove_driver_earnings_from_dashboard', resData.remove_driver_earnings_from_dashboard);
                localStorage.setItem('is_vehicle_decoupling_enabled',resData.is_vehicle_decoupling_enabled);
                localStorage.setItem('is_customer_fare_factor_enabled',resData.is_customer_fare_factor_enabled);
                localStorage.setItem('admin_set_driver_online_status',resData.admin_set_driver_online_status);
                localStorage.setItem('vehicle_set_enabled',resData.vehicle_set_enabled);
                
                localStorage.setItem('is_customer_fare_factor_enabled',resData.is_customer_fare_factor_enabled);
                localStorage.setItem('ride_event_logs_enabled', resData.ride_event_logs_enabled);
                localStorage.setItem('admin_set_driver_online_status',resData.admin_set_driver_online_status);
                // Dispatch custom event to notify GoogleMapsProvider about the google_key update
                window.dispatchEvent(new Event('google_key_updated'));
                
                localStorage.setItem('panel_customer_specific_address', resData.panel_customer_specific_address);
                localStorage.setItem('activation_deactivation_date_range', resData.activation_deactivation_date_range);
                localStorage.setItem('map_search_preference', resData.map_search_preference);
                localStorage.setItem('show_create_schedule_ride_button', resData.show_create_schedule_ride_button);
                localStorage.setItem('show_action_schedule_ride_column', resData.show_action_schedule_ride_column);
                localStorage.setItem('show_user_code_for_panel', resData.show_user_code_for_panel);
                localStorage.setItem('utc_offset', resData.utc_offset);
                localStorage.setItem('time_zone_format', resData.time_zone_format);
                localStorage.setItem('default_country_iso_code', resData.default_country_iso_code);
                localStorage.setItem('remove_driver_pushes', resData.remove_driver_pushes);
                localStorage.setItem('pushes_in_html', resData.pushes_in_html);
                localStorage.setItem('remove_add_stops', resData.remove_add_stops);
                localStorage.setItem('disable_total_rides_for_taxi', resData.disable_total_rides_for_taxi);

                localStorage.setItem('reverse_bid_enabled_panel', resData.reverse_bid_enabled_panel);
                localStorage.setItem('is_bulk_assign_enabled', resData.is_bulk_assign_enabled);
                localStorage.setItem('add_pool_users', resData.add_pool_users);
                localStorage.setItem('show_map_view_cancel_button', resData.show_map_view_cancel_button);
                localStorage.setItem('dashboard_auto_refresh', resData.dashboard_auto_refresh);
                localStorage.setItem('hide_fare_on_map_view_cancel', resData.hide_fare_on_map_view_cancel);
                localStorage.setItem('is_operational_hours_enabled', resData.is_operational_hours_enabled);
                localStorage.setItem('is_offering_type_enabled', resData.is_offering_type_enabled);
                localStorage.setItem('is_delivery_enabled', resData.is_delivery_enabled);
                localStorage.setItem('utc_offset_from_pickup_time', resData.utc_offset_from_pickup_time);
                localStorage.setItem('is_trip_invoice_visible', resData.is_trip_invoice_visible);
                localStorage.setItem('driver_no_show_fare_disabled', resData.driver_no_show_fare_disabled);
                localStorage.setItem('city_manager_enabled',resData.city_manager_enabled);
                localStorage.setItem('call_masking_enabled',resData.call_masking_enabled);
                localStorage.setItem('is_driver_debt_limit_enabled', resData.is_driver_debt_limit_enabled);
                localStorage.setItem('user_specific_promo_enabled', resData.user_specific_promo_enabled);
                localStorage.setItem('show_driver_gps_status', resData.show_driver_gps_status);
                localStorage.setItem('show_trip_id_filter_in_bulk_push', resData.show_trip_id_filter_in_bulk_push);
                localStorage.setItem('multi_tax_system_enabled', resData.multi_tax_system_enabled);
                localStorage.setItem('driver_replace_vehicle_enabled', resData.driver_replace_vehicle_enabled);
            }
            
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    const recoverPassword = () => {
        navigate('/recover-password', { state: { email: email } });
    }

    // Helper function to navigate to the first available tab from a list of tab IDs
    const navigateToFirstAvailableTab = (tabIds) => {
        if (tabIds.length > 0) {
            const firstTabId = parseInt(tabIds[0], 10);
            const tabRoute = constants.TabRoutes[firstTabId];
            if (tabRoute) {
                navigate(tabRoute);
            } else {
                navigate("/mainDashboard");
            }
        } else {
            navigate("/mainDashboard");
        }
    };

    return(
        <>
        <Paper elevation={3} style={{height:'97vh', width:'88vw', alignItems: 'center', justifyContent: 'center', margin: 'auto', borderRadius:'24px' }}>
            <Grid2 container spacing={2}  style={{margin:'2%', marginTop: '1%'}}>

                <Grid2 item size={{ xs: 12, md: 6, lg:6, xl:6 }} style={{marginTop:'2%'}}>
                    <img src={signupImg} alt="signup img" width="100%" height="82%" />
                </Grid2>

                <Grid2 item size={{ xs: 12, md: 5, lg:5, xl:5 }} style={{margin:'2%', marginTop:'10%'}} >
                    <Typography variant="h4" style={{fontWeight:700, fontSize:'32px'}}>Login</Typography>
                    <Typography style={{color:'#83888E', fontSize:'16px'}}>Please Enter Your Email & Password</Typography>

                    <form onSubmit={handleLogin}>
                        <Grid2 style={{marginTop:'20px'}}>
                            <Typography >Email</Typography>
                            <FormControl variant="outlined" style={{marginTop:'2%'}} fullWidth error={!!emailError}>
                                <OutlinedInput 
                                    value={email} 
                                    onChange={handleEmailChange}
                                    type="email"
                                    id="outlined-adornment-weight"
                                    startAdornment={<InputAdornment position="start"><img src={userIcon} alt="signup img" width="100%" height="82%" /></InputAdornment>}
                                    aria-describedby="outlined-weight-helper-text"
                                    inputProps={{
                                        'aria-label': 'email',
                                        placeholder: 'Enter your email',
                                    }}
                                />
                                {emailError && <FormHelperText error>{emailError}</FormHelperText>}
                            </FormControl>
                        </Grid2>

                        <Grid2 style={{marginTop:'20px'}}>
                            <Typography>Password</Typography>
                            <FormControl variant="outlined" style={{marginTop:'2%'}} fullWidth>
                                <OutlinedInput type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                                    id="outlined-adornment-weight"
                                    startAdornment={<InputAdornment position="start"><img src={passwordIcon} alt="signup img" width="100%" height="82%" /></InputAdornment>}
                                    aria-describedby="outlined-weight-helper-text"
                                    inputProps={{
                                        'aria-label': 'password',
                                        placeholder: 'Enter your Password',
                                    }}
                                />
                            </FormControl>
                        </Grid2>

                        {error && (
                            <Typography style={{ color: 'red', marginTop: '12px' }}>{error}</Typography>
                        )}
                        
                        <Grid2 container alignItems="center" justifyContent="space-between" sx={{ marginTop: '12px' }}>
                            <Grid2>
                                <FormControlLabel control={<Checkbox checked={remember} onChange={handleCheckboxChange} />} 
                                    label="Remember Password" sx={{ 
                                        '& .MuiFormControlLabel-label': { fontSize: '14px' } 
                                      }}
                                />
                            </Grid2>

                            <Grid2>
                                <Typography style={{color:'#0065FF', fontSize:'14px', cursor:'pointer'}} onClick={recoverPassword}>Forgot Password?</Typography>
                            </Grid2>
                        </Grid2>
                        
                        <Grid2 style={{marginTop:'8%'}}>
                            <Button type="submit" variant="contained" color="primary" fullWidth style={{padding:'3%'}}>
                                Login
                            </Button>
                        </Grid2>
                    </form>
                </Grid2>

            </Grid2>
        </Paper>
         <Dialog
                open={otpModalOpen}
                onClose={handleOtpClose}
                PaperProps={{
                    style: { borderRadius: '16px', padding: '8px', minWidth: '360px' }
                }}
            >
                <DialogTitle style={{ fontWeight: 700, fontSize: '20px', paddingBottom: '4px' }}>
                    Enter OTP
                </DialogTitle>
 
                <DialogContent>
                    <Typography style={{ color: '#83888E', fontSize: '14px', marginBottom: '16px' }}>
                        A one-time password has been sent to your registered Email. Please enter it below.
                    </Typography>
 
                    <FormControl variant="outlined" fullWidth error={!!otpError}>
                        <OutlinedInput
                            value={otp}
                            onChange={(e) => {
                                setOtp(e.target.value);
                                if (otpError) setOtpError('');
                            }}
                            onKeyDown={(e) => e.key === 'Enter' && handleOtpSubmit()}
                            inputProps={{
                                placeholder: 'Enter OTP',
                                maxLength: 10,
                            }}
                            autoFocus
                            type='number'
                        />
                        {otpError && <FormHelperText error>{otpError}</FormHelperText>}
                    </FormControl>
                </DialogContent>
 
                <DialogActions style={{ padding: '12px 24px 16px', gap: '8px' }}>
                    <Button
                        onClick={handleOtpClose}
                        variant="outlined"
                        style={{ flex: 1, padding: '10px' }}
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={handleOtpSubmit}
                        variant="contained"
                        color="primary"
                        disabled={otpLoading}
                        style={{ flex: 1, padding: '10px',background:'#1976d2' }}
                    >
                        {otpLoading ? 'Verifying...' : 'Verify'}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
        
    );
};

export default Signup;